import React from 'react';
import { Modal } from '../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { ModalHeader } from '../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { ErrorState } from '../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';

interface Props {
  onClose: () => void;
}

export const Error = ({ onClose }: Props) => {
  return (
    <Modal isOpen size="xl" aria={{ labelledby: 'Generate Report' }}>
      <ModalHeader as="h2" id="modal-header">
        Generate Report
      </ModalHeader>

      <ModalCloseButton onClick={onClose} />

      <ModalBody
        css={{
          minHeight: '800px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flex: 1,
        }}
      >
        <ErrorState />
      </ModalBody>

      <ModalFooter>
        <Box flex={1} alignSelf="flex-start">
          <Button variant="subtleInactive" onClick={onClose}>
            Cancel
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
